import { ContentImageCard } from 'components/Cards/ContentImageCard';
import styled from 'styled-components';

export const CapsText = styled.p`
  font-family: 'Moderat Bold';
  font-style: normal;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 2.4rem;
  text-transform: uppercase;
  margin-bottom: 8px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textColors.secondaryDark};
`;

export const Header = styled.h1`
  font-family: 'Ivar Fine Light';
  font-style: normal;
  font-weight: 400;
  font-size: 3.6rem;
  line-height: 4rem;
  margin-bottom: 18px;
  text-align: center;
  ${({ theme }) => `
  color: ${theme.colors.neutralColors.charcoal};
  text-decoration: underline ${theme.colors.brandColors.coral};
  text-underline-offset: 3px;
`}
`;

export const SubHeader = styled.p`
  font-family: 'Moderat';
  font-style: normal;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 24px;
  margin-bottom: 36px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textColors.secondaryDark};
  ${({ theme }) => theme.breakPoints.desktop} {
    margin-bottom: 48px;
  }
`;

export const Title = styled.p`
  font-family: 'Moderat';
  font-style: normal;
  font-weight: 400;
  font-size: 1.8rem;
  line-height: 24px;
  margin-bottom: 16px;
  text-align: left;
`;

export const StyledContentImageCard = styled(ContentImageCard)`
  margin-bottom: 48px;
`;

export const Tile = styled.div`
  padding: 8px 0;
`;

export const ContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 816px;
  padding: 48px 24px 24px 24px;
  position: relative;
`;

export const HeroShroud = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 434px;
  background: ${({ theme }) => theme.colors.brandColors.birchLight};
  z-index: -1;
`;
